import { useEffect } from "react";
import { useModalBaseContext } from "./auth-service-tools286.js";

function useModalBodyId() {
  const ctx = useModalBaseContext();
  useEffect(() => {
    ctx.setBodyMounted(true);
    return () => ctx.setBodyMounted(false);
  }, []);
  return ctx.getBodyId();
}

export { useModalBodyId };